import React from "react";
import { ThemeBasedColorHeader } from "src/shared/modules/profile/theme/themeCheacker";
import { Order } from "src/shared/services/interface";

export default function PaymentDetailsCard({ order, remaining }: { order: Order | any; remaining: number }) {
    if (!order) return null;

    const totalAmount = order.totalAmount ?? 0;
    const discount = order.discount ?? 0;
    const finalAmount = order.Finalamount ?? 0;

    return (
        <div className="bg-white rounded shadow">
            {/* Header */}
            <div className={`${ThemeBasedColorHeader()} text-white p-2 rounded-t`}>
                Payment Details
            </div>

            {/* Body */}
            <div className="p-2 text-sm space-y-1">
                <div className="flex justify-between">
                    <span>Sub Total</span>
                    <span>{totalAmount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                    <span>Discount</span>
                    <span>{discount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between font-medium">
                    <span>Final Amount</span>
                    <span>{finalAmount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between font-semibold">
                    <span>Remaining</span>
                    <span
                        className={
                            remaining > 0
                                ? "text-red-500"
                                : "text-green-600"
                        }
                    >
                        {remaining.toFixed(2)}
                    </span>
                </div>

                <div className="flex justify-between">
                    <span>Payment Type</span>
                    <span>
                        {order.paymentHistory?.[0]?.Paymentmethod || "-"}
                    </span>
                </div>
            </div>
        </div>
    );
}